import React from 'react';
import { ChevronLeft, CheckCircle2 } from 'lucide-react';
interface ScreenProps {
  onNavigate: (screenId: number) => void;
}
export function Screen5({
  onNavigate
}: ScreenProps) {
  return <div className="min-h-full bg-white flex flex-col pb-10" data-id="element-188">
      {/* Header */}
      <div className="px-4 py-4 flex items-center sticky top-0 z-10 bg-white" data-id="element-189">
        <button onClick={() => onNavigate(4)} className="p-2 -ml-2 text-slate-600 hover:bg-slate-50 rounded-full transition-colors" data-id="element-190">
          <ChevronLeft className="w-6 h-6" data-id="element-191" />
        </button>
        <h1 className="text-base font-bold text-datmont-900 ml-2" data-id="element-192">
          Verification Result
        </h1>
      </div>

      <div className="flex-1 px-6 py-8 flex flex-col items-center" data-id="element-193">
        {/* Success Icon */}
        <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mb-6 relative" data-id="element-194">
          <div className="absolute inset-0 bg-green-50 rounded-full scale-150 animate-pulse" data-id="element-195"></div>
          <CheckCircle2 className="w-14 h-14 text-datmont-green relative z-10" data-id="element-196" />
        </div>

        <h2 className="text-2xl font-black text-datmont-green tracking-wider mb-2" data-id="element-197">
          VERIFIED
        </h2>
        <p className="text-sm text-slate-500 mb-10" data-id="element-198">
          Instant Authentication Successful
        </p>

        {/* Verification Details */}
        <div className="w-full space-y-5 mb-10" data-id="element-199">
          <div className="flex items-center justify-between border-b border-slate-100 pb-4" data-id="element-200">
            <div data-id="element-201">
              <p className="text-sm font-bold text-datmont-900" data-id="element-202">Issuer</p>
              <p className="text-xs text-slate-500" data-id="element-203">
                Federal Bureau of Investigation (FBI)
              </p>
            </div>
            <span className="px-2.5 py-1 bg-green-50 text-datmont-green text-[10px] font-bold uppercase tracking-wider rounded-md border border-green-100" data-id="element-204">
              Trusted
            </span>
          </div>

          <div className="flex items-center justify-between border-b border-slate-100 pb-4" data-id="element-205">
            <div data-id="element-206">
              <p className="text-sm font-bold text-datmont-900" data-id="element-207">Integrity</p>
              <p className="text-xs text-slate-500" data-id="element-208">Match Confirmed</p>
            </div>
            <span className="px-2.5 py-1 bg-green-50 text-datmont-green text-[10px] font-bold uppercase tracking-wider rounded-md border border-green-100" data-id="element-209">
              Match
            </span>
          </div>

          <div className="flex items-center justify-between border-b border-slate-100 pb-4" data-id="element-210">
            <div data-id="element-211">
              <p className="text-sm font-bold text-datmont-900" data-id="element-212">Validity</p>
              <p className="text-xs text-slate-500" data-id="element-213">Document is Valid</p>
            </div>
            <span className="px-2.5 py-1 bg-green-50 text-datmont-green text-[10px] font-bold uppercase tracking-wider rounded-md border border-green-100" data-id="element-214">
              Valid
            </span>
          </div>

          <div className="flex items-center justify-between border-b border-slate-100 pb-4" data-id="element-215">
            <div data-id="element-216">
              <p className="text-sm font-bold text-datmont-900" data-id="element-217">Policy Check</p>
              <p className="text-xs text-slate-500" data-id="element-218">Meets Requirements</p>
            </div>
            <span className="px-2.5 py-1 bg-green-50 text-datmont-green text-[10px] font-bold uppercase tracking-wider rounded-md border border-green-100" data-id="element-219">
              Acceptable
            </span>
          </div>
        </div>

        {/* Final Decision */}
        <button onClick={() => onNavigate(6)} className="w-full py-4 bg-white border-2 border-datmont-green rounded-xl flex flex-col items-center justify-center gap-1 shadow-sm hover:bg-green-50 transition-colors" data-id="element-220">
          <span className="text-[10px] font-bold text-slate-500 uppercase tracking-widest" data-id="element-221">
            Final Decision
          </span>
          <div className="flex items-center gap-2" data-id="element-222">
            <CheckCircle2 className="w-5 h-5 text-datmont-green" data-id="element-223" />
            <span className="text-lg font-bold text-datmont-green" data-id="element-224">
              ACCEPTED
            </span>
          </div>
        </button>
      </div>
    </div>;
}